// extracted by mini-css-extract-plugin
export default {"settings":"Info_settings__z-iF3","title":"Info_title__K+0CB","tabs":"Info_tabs__qEAax","content":"Info_content__nO-eD"};